<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>{{'Coupon.Title' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<!-- Consult about design of this page how they want it -->
<div class="container" id="container" (click)="track($event)" >
  @if (coupon) {
    <div class="full-coupon" #fullCoupon>
      <div class="view-coupon-front" #couponFront>
        <div class="title-heading" style="margin-bottom: 0px;">
          <div>Coupon Expire: &nbsp; </div>
          <div>
            <span #days></span><ng-container><span #hours></span><span #minutes></span><span #seconds></span></ng-container>
          </div>
        </div>
        <div class="container2">
          <div class="image-container">
            <div class="img-container">
              <!-- for large image -->
              @if (!isReachedUsageLimit) {
                <img class="main-image" [src]="coupon.ImageLargeUrl">
              }
              @if (isReachedUsageLimit) {
                <div style="font-size: 28pt; color:red;">{{ 'General.ExpiredPromo' | translate}}</div>
              }
            </div>
          </div>
          <div class="coupon-title">
            {{ getCouponTranslationName(coupon.Translations) }}
          </div>
          @if (!isGlobalCouponCode) {
            @if (couponCode) {
              <div class="barcode">
                @if (currentSegment=='qrcode') {
                  <qr-code  [value]="couponCode"></qr-code>
                }
                @if (currentSegment=='barcode') {
                  <barcode id="barcode" [value]="couponCode"></barcode>
                }
              </div>
            }
          }
          @if (isGlobalCouponCode) {
            @if (globalCouponCode) {
              <div class="barcode">
                @if (currentSegment=='qrcode') {
                  <qr-code  [value]="globalCouponCode"></qr-code>
                }
                @if (currentSegment=='barcode') {
                  <barcode id="barcode" [value]="globalCouponCode"></barcode>
                }
              </div>
            }
          }
          <div class="buttons">
            <ion-segment style="width: 100px;">
              <ion-segment-button style="min-width: 0px;"  value="qrcode" (click)="change('qrcode')">
                <ion-icon name="qr-code-outline"></ion-icon>
              </ion-segment-button>
              <ion-segment-button style="min-width: 0px;" (click)="change('barcode')">
                <ion-icon name="barcode-outline"></ion-icon>
              </ion-segment-button>
            </ion-segment>
          </div>
          @if (isOrder) {
            <ion-select>
              @for (type of orderTypes; track type; let i = $index) {
                <ion-select-option  [value]="type">{{type}}</ion-select-option>
              }
            </ion-select>
          }
          <div class="coupon-code">
            <div class="coupon-heading">{{'Coupon.CouponCode' | translate}} @if (!isGlobalCouponCode) {
              <span>{{transform(couponCode)}}</span>
            }
            @if (isGlobalCouponCode) {
              <span >{{transform(globalCouponCode)}}</span>
            }
          </div>
          <!-- <div class="coupon-number">
          <div>{{couponNum}}</div>
        </div> -->
      </div>
      <div class="deal">
        <div  class="heading">@if (coupon.Type<=2) {
          {{'Coupon.Discount' | translate}}: {{coupon.Amount}}
        }
        @if (coupon.Type ===  couponsType.REWARD_FIX || coupon.Type ===  couponsType.REWARD_RATIO) {
          Bonus: {{coupon.Amount}}
        }
        @if (coupon.Type === couponsType.PERCENT) {
          <span>%</span>
        }
        @if (coupon.Type === couponsType.DOLLAR) {
          <span>$</span>
        }
        <span style="color: rgba(0, 0, 0, 0.626) !important;"> expire {{coupon.ExpirationDate | date }}</span></div>
      </div>
      @if (!isReachedUsageLimit) {
        <div class="btn">
          <button (click)="checkout()" class="apply">{{'Coupon.Button' | translate}}</button>
        </div>
      }
      <div class="termline">
        <div class="detail"><a class="coupon-terms" (click)="flip()">({{'Coupon.Terms' | translate}})</a></div>
      </div>
    </div>
    <ion-item class="invisible">
      <ion-label>{{'Store.PickOrderType' | translate}}</ion-label>
      <ion-select  class="invisible" (ionChange)="chooseOrderType($event)" #selectOrderType>
        @if (menuService.store) {
          @for (orderType of orderTypes; track orderType; let i = $index) {
            @if (menuService.store.allowPickup && orderType.value=='pickup' ) {
              <ion-select-option [value]="orderType.value">{{orderType.type.translations[lang]}}</ion-select-option>
            }
            @if (menuService.store.allowDelivery && orderType.value=='delivery') {
              <ion-select-option [value]="orderType.value">{{orderType.type.translations[lang]}}</ion-select-option>
            }
          }
        }
      </ion-select>
    </ion-item>
  </div>
  <div (click)="turnBack()" class="view-coupon-back hide" #couponBack>
    <div    class="back-container" id="backContainer">
      <div class="title-heading">
        <div class="terms">{{'Coupon.Term' | translate}}</div>
      </div>
      <div class="conditions">
        <p>{{getCouponTranslationTerms(coupon.Translations)}}</p>
      </div>
    </div>
  </div>
</div>
}

</div>